<template>
  <div class="index-page">
    <div class="banner">
      <van-swipe :autoplay="3000" indicator-color="white">
        <van-swipe-item>
          <div class="banner-item">
            <img src="https://www.jhsqwsfwz.cn/profile/upload/img/banner.png" alt="专业医疗服务" />
          </div>
        </van-swipe-item>
       <van-swipe-item>
          <div class="banner-item">
            <img src="https://www.jhsqwsfwz.cn/profile/upload/img/banner1.png" alt="专业医疗服务" />
          </div>
        </van-swipe-item>
        <van-swipe-item>
          <div class="banner-item">
            <img src="https://www.jhsqwsfwz.cn/profile/upload/img/banner2.jpg" alt="专业医疗服务" />
          </div>
        </van-swipe-item>
        <van-swipe-item>
          <div class="banner-item">
            <img src="https://www.jhsqwsfwz.cn/profile/upload/img/banner3.jpg" alt="专业医疗服务" />
          </div>
        </van-swipe-item>
        <van-swipe-item>
          <div class="banner-item">
            <img src="https://www.jhsqwsfwz.cn/profile/upload/img/banner4.jpg" alt="专业医疗服务" />
          </div>
        </van-swipe-item>
        <van-swipe-item>
          <div class="banner-item">
            <img src="https://www.jhsqwsfwz.cn/profile/upload/img/banner5.jpg" alt="专业医疗服务" />
          </div>
        </van-swipe-item>
        <van-swipe-item>
          <div class="banner-item">
            <img src="https://www.jhsqwsfwz.cn/profile/upload/img/banner6.jpg" alt="专业医疗服务" />
          </div>
        </van-swipe-item>
        <van-swipe-item>
          <div class="banner-item">
            <img src="https://www.jhsqwsfwz.cn/profile/upload/img/banner7.jpg" alt="专业医疗服务" />
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>

    <div class="clinic-info">
      <div class="info-header">
        <van-icon name="info-o" color="#3e97c1" size="20" />
        <span>服务站简介</span>
      </div>
      <div class="info-content">
        <p>金河社区卫生服务站是一所集全科医疗、社区卫生服务、公共卫生管理于一体的综合性社区卫生服务机构，为省、市及异地医保定点统筹单位。站内设有：全科医疗科、中医科、内科、口腔科、医学检验科（临床体液、血液专业）、医学影像科（X射线诊断专业、超声诊断专业、心电诊断专业）等多个科室。</p>
        <p>我们将以一流的服务品质、先进的诊疗技术，严格保障医疗质量与安全，致力打造成让群众满意的社区卫生服务站。</p>
      </div>
    </div>

    <div class="features">
      <van-grid :column-num="3" :border="false">
        <van-grid-item icon="friends-o" text="专业团队" />
        <van-grid-item icon="clock-o" text="便捷预约" />
        <van-grid-item icon="shield-o" text="安全保障" />
      </van-grid>
    </div>

    <div class="notice-section">
      <div class="section-header">
        <van-icon name="bell" color="#ff976a" size="18" />
        <span>预约须知</span>
      </div>
      <div class="notice-list">
        <div class="notice-item">
          <span class="notice-num">1</span>
          <span class="notice-text">预约成功后请按时就诊，如需取消请提前在"我的预约"中操作</span>
        </div>
        <div class="notice-item">
          <span class="notice-num">2</span>
          <span class="notice-text">就诊当天请提前10分钟到达服务站</span>
        </div>
        <div class="notice-item">
          <span class="notice-num">3</span>
          <span class="notice-text">如遇医生临时停诊，我们会通过微信或电话通知您，请注意查收</span>
        </div>

      </div>
    </div>

    <div class="contact-section">
      <div class="section-header">
        <van-icon name="phone-o" color="#3e97c1" size="18" />
        <span>联系我们</span>
      </div>
      <van-cell-group>
        <van-cell title="服务站地址" value="济南市历城区飞跃大道钢城新苑东区36B2-104" icon="location-o" />
        <van-cell title="联系电话" value="88856286,88110096" icon="phone-o" />
        <van-cell title="营业时间" value="周一至周日 8:00-21:00" icon="clock-o" />
      </van-cell-group>
    </div>
   <div style="text-align:center; margin:10px 0; font-size:14px; color:#666;">
     <a href="https://beian.miit.gov.cn/" target="_blank" style="color:#666; text-decoration:none;">鲁ICP备2026015774号-1</a>
     &nbsp;|&nbsp;
     <a href="https://beian.mps.gov.cn/#/query/webSearch?code=37011202002724" target="_blank" style=" text-decoration:none;">
       <img src="../../assets/img/beian.png" alt="网安备案" style="width:14px; height:14px; vertical-align:middle; margin-right:4px;">
       鲁公网安备37011202002724号
     </a>
   </div>

    <div style="height: 70px;"></div>
    <van-tabbar v-model="active" @change="onChange">
      <van-tabbar-item icon="home-o" to="/index/index">首页</van-tabbar-item>
      <van-tabbar-item icon="calendar-o" to="/yuyue/index">预约</van-tabbar-item>
      <van-tabbar-item icon="user-o" to="/mine/index">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'IndexPage',
  data() {
    return {
      active: 0
    }
  },
  methods: {
    onChange(index) {
      console.log('切换到索引：', index)
    }
  }
}
</script>

<style scoped>
.index-page {
  background: #f5f5f5;
  min-height: 100vh;
}
.van-tabbar-item--active {
  color: #3e97c1;
}
.banner {
  height: 200px;
}
.banner-item {
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-position: center;
}
.banner-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.clinic-info {
  background: #fff;
  margin: 10px;
  border-radius: 8px;
  padding: 15px;
}
.info-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
.info-header .van-icon {
  margin-right: 8px;
}
.info-content {
  font-size: 14px;
  color: #666;
  line-height: 1.8;
}
.info-content p {
  margin: 0 0 10px 0;
}
.info-content p:last-child {
  margin-bottom: 0;
}
.features {
  background: #fff;
  margin: 10px;
  border-radius: 8px;
  overflow: hidden;
}
.notice-section {
  background: #fff;
  margin: 10px;
  border-radius: 8px;
  padding: 15px;
}
.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
.section-header .van-icon {
  margin-right: 8px;
}
.notice-list {
  padding-left: 5px;
}
.notice-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
}
.notice-item:last-child {
  margin-bottom: 0;
}
.notice-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background: #3e97c1;
  color: #fff;
  border-radius: 50%;
  font-size: 12px;
  margin-right: 10px;
  flex-shrink: 0;
}
.notice-text {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}
.contact-section {
  background: #fff;
  margin: 10px;
  border-radius: 8px;
  overflow: hidden;
}
.contact-section .section-header {
  padding: 15px 15px 0 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue